import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	alertsEnabledErrorTitle: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-enabled-error-title',
		defaultMessage: "We couldn't enable responder alerts",
		description:
			'The title text in the error flag if the responder alerts configuration status can not be updated to "on" when POSTing to the endpoint.',
	},
	alertsDisabledErrorTitle: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-disabled-error-title',
		defaultMessage: "We couldn't disable responder alerts",
		description:
			'The title text in the status flag if the responder alerts configuration status can not be updated to "off" when POSTing to the endpoint.',
	},
	alertsToggleErrorDescription: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-toggle-error-description',
		defaultMessage: 'Wait a moment then try use the toggle or refresh the page',
		description:
			'The title text in the status flag if the responder alerts configuration status can not be updated to "off" when POSTing to the endpoint.',
	},
	alertsEnabledFlagHeading: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-enabled-flag-heading',
		defaultMessage: 'Responder alerts enabled',
		description: 'Title of the flag shown when user toggles "should send responder alerts" to "on"',
	},
	alertsEnabledFlagText: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-enabled-flag-text',
		defaultMessage:
			'Add the responders field to incident requests to create and acknowledge responder alerts quickly.',
		description:
			'Description of the flag shown when user toggles "should send responder alerts" to "on"',
	},
	alertsEnabledLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-enabled-learn-more-link',
		defaultMessage: 'Learn how to add responders.',
		description: 'Link to public atlassian docs when a user turns on responder alerts',
	},
	alertsDisabledFlagHeading: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-disabled-flag-heading',
		defaultMessage: 'Responder alerts disabled',
		description:
			'Title of the flag shown when user toggles "should send responder alerts" to "off"',
	},
	alertsDisabledFlagText: {
		id: 'servicedesk-incident-management-settings.services.actions.set-responder-alerts-configuration.alerts-disabled-flag-text',
		defaultMessage:
			'New incidents won’t create responder alerts. You can enable alerts again at any time.',
		description:
			'Description of the flag shown when user toggles "should send responder alerts" to "off"',
	},
});
